// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Yhhqb","truncatedText":"styles_truncatedText__oqThN","fullText":"styles_fullText__rYpFi","textContainer":"styles_textContainer__R6gSi"};